import React, {useState} from "react"
import {OrgSettingsTab} from "../types"
import {OrgHeader} from "./OrgHeader"
import {RulesetTab} from "@/features/rulesets"
import {UserManagementTab} from "@/features/user-management"
import {IntegrationTab} from "@/features/integrations"
import {IconShield, IconUsers, IconPlug, IconKey} from "@tabler/icons-react"

const TAB_CONFIG = [
  {
    id: "users" as OrgSettingsTab,
    label: "Users",
    icon: IconUsers,
    description: "Manage organization users",
  },
  {
    id: "rulesets" as OrgSettingsTab,
    label: "Rulesets",
    icon: IconShield,
    description: "Manage archiving rules and filters",
  },
  {
    id: "integrations" as OrgSettingsTab,
    label: "Integrations",
    icon: IconPlug,
    description: "Manage all platform integrations",
  },
]

export function OrgSettingsLayout() {
  const [activeTab, setActiveTab] = useState<OrgSettingsTab>("users")

  const renderTabContent = () => {
    switch (activeTab) {
      case "rulesets":
        return <RulesetTab />
      case "users":
        return <UserManagementTab />
      case "integrations":
        return (
          <IntegrationTab
            title="Integrations"
            description="Manage authentication, user import, and data source integrations"
            icon={IconPlug}
            integrationTypes={[
              "Authentication",
              "HR & Directory",
              "Messaging",
              "Storage",
              "Call Center",
            ]}
            themeColor="blue"
            showInfoBoxes={false}
            context="archiving"
          />
        )
      default:
        return <RulesetTab />
    }
  }

  return (
    <div className="mr-4 flex h-full w-full flex-col gap-4 rounded-md bg-onyx-white p-4">
      <OrgHeader />

      {/* Tab Navigation */}
      <div className="flex flex-shrink-0 overflow-hidden rounded-lg border border-black/5 bg-white shadow-sm">
        <div className="flex w-full">
          {TAB_CONFIG.map((tab) => {
            const Icon = tab.icon
            const isActive = activeTab === tab.id

            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex flex-1 items-center justify-center gap-3 px-6 py-4 transition-all duration-200 ${
                  isActive
                    ? "border-b-2 border-blue-500 bg-blue-50 text-blue-700"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-800"
                }`}
              >
                <Icon size={20} />
                <div className="flex flex-col items-start">
                  <span className="font-medium">{tab.label}</span>
                  <span className="text-xs opacity-75">{tab.description}</span>
                </div>
              </button>
            )
          })}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-auto">{renderTabContent()}</div>
    </div>
  )
}
